import "../TeamAssignment.scss";

import {useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {FmlxButton} from "fmlx-common-ui";
import {fetchHistoryData} from "../../../stores/business/teamAssignmentBusiness";
import EssSimpleTable from "../../../components/MessageTable/TableColumn/EssSimpleTable";
import {selectIsLoadingHistory, selectTeamMemberHistory} from "../../../stores/selectors/teamAssignmentSelector";
import Loading from "../../../components/Loading/Loading";

const TeamMemberHistory = () => {
  const selectedProject = useSelector(state => state.teamAssignmentState.selectedProject);
  const [showHistory, setShowHistory] = useState(false);
  const isLoading = useSelector(selectIsLoadingHistory)
  const historyData = useSelector(selectTeamMemberHistory)
  const dispatch = useDispatch()

  const columns = [
    {
      id: "name",
      Header: "Name",
      accessor: "fullName",
    },
    {
      id: "department",
      Header: "Department",
      accessor: "departmentName",
    },
    {
      id: "role",
      Header: "Role",
      accessor: "teamRole",
    },
    {
      id: "joinDate",
      Header: "Join Date",
      accessor: "joinDate",
    },
    {
      id: "outDate",
      Header: "Out Date",
      accessor: "outDate",
    },
  ];

  const tableData = historyData.map((data) => ({
    id: data.employee.id,
    fullName: data.employee.fullName,
    departmentName: data.employee?.practice?.department?.departmentName || "-",
    teamRole: data.teamRole || "-",
    joinDate: data.joinDate ? data.joinDate.slice(0, 10) : "-",
    outDate: data.outDate ? data.outDate.slice(0, 10) : "-",
  }));

  const handleToggleHistory = () => {
    if (showHistory) {
      setShowHistory(false);
    } else {
      if (historyData.length === 0) {
        dispatch(fetchHistoryData(selectedProject.id));
      }
      setShowHistory(true);
    }
  };


  return (
    <>
      <FmlxButton
        label={showHistory ? "Hide Team Member History" : "Show Team Member History"}
        type="secondary"
        variant="contain"
        onClick={handleToggleHistory}
        disabled={isLoading || !selectedProject?.id}
      />

      <div className="team-member-history-table">
        {showHistory && (
          <>
            {isLoading ? (
              <Loading/>
            ) : (
              <EssSimpleTable
                columnData={columns}
                filteredData={tableData}
                dataCount={tableData.length}
                hideFooter={true}
                onEmptyDataShow="No team member history available"
                columns={(column, row) => row[column.accessor]}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default TeamMemberHistory;